import React, { useState } from "react";
import LocationHeading from "../../../shared/LocationHeading";
import { Link, useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { FaChevronDown } from "react-icons/fa";

const AddCoupon = () => {
  const [couponData, setCouponData] = useState({
    title: "",
    applicableOn: "",
    couponAmount: "",
    couponPercentage: "",
    startDate: "",
    endDate: "",
    couponCode: "",
  });
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const formatDateToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}-${dd}-${yyyy}`;
  };

  const validateData = () => {
    const startDate = couponData.startDate;
    const endDate = couponData.endDate;
    if (!couponData.title) {
      toast.error("Please enter coupon title");
      return false;
    }
    if (!couponData.couponCode) {
      toast.error("Please enter coupon code");
      return false;
    }
    if (!couponData.applicableOn) {
      toast.error("Please enter applicable on");
      return false;
    }
    if (couponData.applicableOn === "plots") {
      if (!couponData.couponAmount && !couponData.couponPercentage) {
        toast.error("Please enter coupon amount or coupon percentage");
        return false;
      }
    }
    if (!startDate || !endDate) {
      toast.error("Please select start date and end date");
      return false;
    }
    if (startDate > endDate) {
      toast.error("Start date should be less than end date");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("token");
    if (!validateData()) return;

    const formattedData = {
      title: couponData.title,
      applicableOn: couponData.applicableOn,
      startDate: formatDateToMMDDYYYY(couponData.startDate),
      endDate: formatDateToMMDDYYYY(couponData.endDate),
      couponAmount:
        couponData.couponAmount !== "" ? Number(couponData.couponAmount) : null,
      couponCode: couponData.couponCode,
      couponPercentage:
        couponData.couponPercentage !== ""
          ? Number(couponData.couponPercentage)
          : null,
    };
    setLoader(true);
    try {
      const result = await api.addCoupon(formattedData, token);
      if (result?.status) {
        setLoader(false);
        setCouponData({
          title: "",
          applicableOn: "",
          couponAmount: "",
          couponPercentage: "",
          startDate: "",
          endDate: "",
          couponCode: "",
        });
        handleBack();
        toast.success(result?.message || "Coupon added successfully");
      }
    } catch (error) {
      setLoader(false);
      toast.error(error?.response?.data?.message || "Something went wrong");
      console.error("Error adding coupon:", error);
    }
    setLoader(false);
  };

  const handleReset = () => {
    const isAllEmpty = Object.values(couponData).every((val) => !val);

    setCouponData({
      title: "",
      applicableOn: "",
      couponAmount: "",
      couponPercentage: "",
      startDate: "",
      couponCode: "",
      endDate: "",
    });

    if (!isAllEmpty) {
      toast.success("Coupon reset successfully");
    }
  };

  const handleBack = () => {
    navigate(`/couponSetup`);
  };

  return (
    <>
      <div className="add-location-main">
        <LocationHeading
          title={[
            <Link to={`/couponSetup`}>
              <i
                style={{
                  color: "#000",
                  fontSize: "16px",
                  marginBottom: "10px",
                }}
                className="fa fa-long-arrow-left me-2"
                aria-hidden="true"
              ></i>
            </Link>,
            "Add Coupon",
          ]}
        />
        <div className="blog-info-main add-coupon-main">
          <div className="blog-info">
            <div className="title">
              <label>Coupon Title</label>
              <input
                type="text"
                name="title"
                placeholder="Enter here"
                value={couponData.title}
                onChange={(e) =>
                  setCouponData({ ...couponData, title: e.target.value })
                }
              />
            </div>
            <div className="title">
              <label>Coupon Code</label>
              <input
                type="text"
                name="couponCode"
                placeholder="Enter here"
                value={couponData.couponCode}
                onChange={(e) =>
                  setCouponData({ ...couponData, couponCode: e.target.value })
                }
              />
            </div>

            <div className="title">
              <label>
                Applicable on{" "}
                {couponData.applicableOn === "plots" && (
                  <span>
                    (Add one at a time either coupon amount or percentage)
                  </span>
                )}
              </label>
              <select
                name="applicableOn"
                value={couponData.applicableOn}
                onChange={(e) =>
                  setCouponData({
                    ...couponData,
                    applicableOn: e.target.value,
                  })
                }
              >
                <option value="" disabled>
                  Select
                </option>
                <option value="plots">Plots</option>
                <option value="Flower">Flowers</option>
                <option value="Tree">Trees</option>
              </select>
            </div>

            {couponData.applicableOn === "plots" && (
              <>
                <div className="title">
                  <label>Coupon Amount</label>
                  <input
                    type="number"
                    min={0}
                    name="couponAmount"
                    placeholder="€"
                    disabled={couponData.couponPercentage !== ""}
                    value={couponData.couponAmount}
                    onChange={(e) => {
                      const amount = e.target.value;

                      // Allow empty value (for clearing input) or only digits
                      if (!/^\d*$/.test(amount)) return;

                      setCouponData({
                        ...couponData,
                        couponAmount: amount,
                        couponPercentage: "",
                      });
                    }}
                    onKeyDown={(e) => {
                      // Block "e", "E", "+", "-", ".", ","
                      if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className="title">
                  <label>Coupon Percentage</label>
                  <input
                    type="number"
                    name="couponPercentage"
                    placeholder="%"
                    min={0}
                    disabled={couponData.couponAmount !== ""}
                    value={couponData.couponPercentage}
                    onChange={(e) => {
                      const percentage = e.target.value;

                      // Allow empty value (for clearing input) or only digits
                      if (!/^\d*$/.test(percentage)) return;

                      setCouponData({
                        ...couponData,
                        couponPercentage: percentage,
                        couponAmount: "",
                      });
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    // onChange={(e) => {
                    //   const percentage = e.target.value;
                    //   if (couponData.couponAmount && percentage) {
                    //     toast.error(
                    //       "You can only enter either amount or percentage, not both"
                    //     );
                    //     return;
                    //   }
                    //   setCouponData({
                    //     ...couponData,
                    //     couponPercentage: percentage,
                    //     couponAmount: "",
                    //   });
                    // }}
                  />
                </div>{" "}
              </>
            )}

            <div className="title">
              <label>Start Date</label>
              <input
                type="date"
                name="startDate"
                min={new Date().toISOString().split("T")[0]}
                value={couponData.startDate}
                onChange={(e) =>
                  setCouponData({ ...couponData, startDate: e.target.value })
                }
              />
            </div>

            <div className="title">
              <label>End Date</label>
              <input
                type="date"
                name="endDate"
                min={couponData.startDate || ""}
                value={couponData.endDate}
                onChange={(e) =>
                  setCouponData({ ...couponData, endDate: e.target.value })
                }
              />
            </div>
          </div>

          <div className="blog-btn">
            <div className="blog-save">
              <button className="draft-btn" onClick={handleReset}>
                Reset
              </button>
              <button onClick={handleSubmit}>Submit</button>
            </div>
          </div>
          {/* {loader && (
          <div className="overlay">
            <Loading />
          </div>
        )} */}
        </div>
      </div>
    </>
  );
};

export default AddCoupon;
